<div class="mb-[180px]">
  <div class="relative">
    <ng-content select="[progressIcon]" />
    <mat-progress-bar mode="determinate" [value]="stepProgress()" />
  </div>
  <div class="flex flex-col gap-10">
    <ng-content />
  </div>
</div>
